export default {
  name: 'SvgIcon',
  props: {
    /**
     * data-cy para o cypress
     */
    dataCy: {
      type: String,
      default: 'mf-icon'
    },
    /**
     * Nome do ícone
     */
    icon: {
      type: String,
      default: ''
    },
    /**
     * Tamanho do ícone
     */
    size: {
      type: [String, Number],
      default: '16'
    },
    /**
     * Cor do ícone
     */
    color: {
      type: String,
      default: ''
    },
    /**
     * conjunto de eventos 'on' do vuetify
     */
    on: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * bind de atributos do vuetify
     */
    attrs: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  emits: ['click', 'mouseleave', 'mouseover'],
  data() {
    return {
      uid: Math.random().toString(36).substring(2, 9)
    };
  }
};